<template>
    <div class="page-upgrade-notice">
        <div class="page-upgrade-notice__content">
            <img class="page-upgrade-notice__image" src="@/assets/images/learningpaths/learningpath_landingpage.png" alt="Learning paths" />
            <h2 class="page-upgrade-notice__title" v-html="$t('PageUpgradeNotice.title', { collectionName: singleCollection.title })"></h2>
            <p class="page-upgrade-notice__paragraph" v-html="$t('PageUpgradeNotice.paragraph')"></p>
            <TotemButton
                class="page-upgrade-notice__button"
                color="primary"
                @click="goToLearningPath"
                :label="$t('PageUpgradeNotice.go_to_learning_path')"
            />
        </div>
    </div>
</template>

<script>
    import routeHelper from 'components/shared/mixins/routeHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'page-upgrade-notice',
        mixins: [routeHelper],
        computed: {
            ...mapGetters({
                'singleCollection': 'CoursesCollections/getSingleCollection'
            })
        },
        methods: {
            goToLearningPath () {
                let learningPathSlug = this.singleCollection.learningPathId + this.singleCollection.slug.slice(this.singleCollection.id.toString().length)
                this.$router.push(this.getRouteToLearningPath(learningPathSlug))
            }
        },
        created () {
            this.$store.dispatch('CoursesCollections/loadSingleCollection', this.$route.params.collectionSlug)
        }
    }
</script>

<style lang="scss" scoped>
    .page-upgrade-notice {
        background: $alabaster;
        padding-bottom: 5px;

            [class*="desktop"] & {
            padding-bottom: 140px;
        }

        &__content {
            padding: 30px 0;
            margin: 30px;
            display: flex;
            flex-direction: column;
            text-align: center;
            max-width: 860px;
            box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
            border-radius: 10px;
            background: $white;

            [class*="desktop"] & {
                margin: 80px auto 0;
            }
        }

        &__image {
            margin: 0 auto;
            width: 158px;
        }

        &__button {
            margin: 0 auto;
        }

        &__title {
            margin: 30px;
            font-size: 1.8rem;
            line-height: 2.2rem;
            font-weight: 500;

            [class*="desktop"] & {
                font-size: 2.4rem;
                line-height: 3rem;
            }
        }

        &__paragraph {
            font-size: 1.5rem;
            line-height: 2rem;
            margin: 0 40px 30px;

            [class*="desktop"] & {
                font-size: 1.8rem;
                line-height: 2.4rem;
            }
        }
    }
</style>
